import React, { ReactNode, createContext, useContext } from "react";
import { Toast } from "primereact/toast";

export const enum ToastSeverity {
  SUCCESS = "success",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}

interface ToastContextType {
  showToast: (message: string, severity: ToastSeverity) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

const ToastContextProvider = ({ children }: { children: ReactNode }) => {
  const toastRef = React.useRef<Toast>(null);

  const showToast = (message: string, severity: ToastSeverity) => {
    if (toastRef.current) {
      toastRef.current.show({
        severity,
        summary: "Notificatie",
        detail: message,
        life: 3000,
      });
    }
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast ref={toastRef} position="bottom-right" />
    </ToastContext.Provider>
  );
};

const useToastContext = () => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error(
      "useToastContext have to be used within ToastContextProvider",
    );
  }

  return context;
};

export { ToastContext, ToastContextProvider, useToastContext };
